import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { buttonWhiteSX } from '@/components/blocks/DpLibrary/DpButton/style/white';
import {
	buttonCouponCardSX,
	containerCouponCardSX,
	descriptionCouponCardSX,
	discountCouponCardSX,
	expirationCouponCardSX,
	eyebrowCouponCardSX,
	offCouponCardSX,
	offerCouponCardSX,
	ticketCouponCardSX,
	watermarkCouponCardSX,
} from '@/components/blocks/DpLibrary/DpCouponCard/styles';
import { combineSX } from '@/utils/combineSX';
import { Box, Grid, SxProps, Theme, Typography } from '@mui/material';
import { MouseEvent } from 'react';
import { UrlObject } from 'url';

type DpCouponCardProps = {
	name?: string;
	discount: string | number;
	description?: string;
	remaining?: string;
	expiration?: string;
	button?: string;
	href?: string | UrlObject;
	onClick?: (e: MouseEvent<HTMLElement>) => void;
	sx?: SxProps<Theme>;
};

/**
 * Tarjeta del cupón de recompra para el listado de productos. Igual que dp-product-grid-card,
 * ocupa la celda de un producto del grid y toma el alto de la fila.
 */
export const DpCouponCard = ({
	name,
	discount,
	description = 'en tu siguiente compra',
	remaining,
	expiration,
	button = 'Mi selección',
	href,
	onClick,
	sx,
}: DpCouponCardProps) => (
	<Grid item xs={6} md={4} display="flex">
		<Box sx={combineSX([containerCouponCardSX, ...(Array.isArray(sx) ? sx : [sx])])}>
			<Box aria-hidden="true" sx={watermarkCouponCardSX}>
				{'%'}
			</Box>
			<Box sx={ticketCouponCardSX}>
				<Typography sx={eyebrowCouponCardSX}>{name ? `Para ti, ${name}` : 'Para ti'}</Typography>
				<Box sx={offerCouponCardSX}>
					<Typography sx={discountCouponCardSX}>{discount}</Typography>
					<Typography sx={offCouponCardSX}>{'OFF'}</Typography>
					{description ? <Typography sx={descriptionCouponCardSX}>{description}</Typography> : null}
				</Box>
				{remaining ? (
					<Typography sx={expirationCouponCardSX}>
						{`Vence en ${remaining}`}
						{expiration ? (
							<Typography component="span" fontSize="inherit" fontWeight="inherit">
								{` · ${expiration}`}
							</Typography>
						) : null}
					</Typography>
				) : expiration ? (
					<Typography sx={expirationCouponCardSX}>{`Activo hasta el ${expiration}`}</Typography>
				) : null}
				<DpButton
					text={`${button} →`}
					href={href}
					onClick={onClick}
					sx={combineSX([buttonWhiteSX, buttonCouponCardSX])}
				/>
			</Box>
		</Box>
	</Grid>
);
